import { render } from "./OutStorageRecordDetail.vue?vue&type=template&id=7ba01853&scoped=true"
import script from "./OutStorageRecordDetail.vue?vue&type=script&lang=js"
export * from "./OutStorageRecordDetail.vue?vue&type=script&lang=js"

import "./OutStorageRecordDetail.vue?vue&type=style&index=0&id=7ba01853&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba01853"]])

export default __exports__